import React, { useEffect } from 'react'

import { applyMiddleware, createStore } from 'redux'
import { Provider, useDispatch } from 'react-redux'
import { createLogger } from 'redux-logger'

import createSagaMiddleware from 'redux-saga'

import rootReducer, { rootSaga } from 'src/ducks/rootReducer'
import { identity, compose } from 'ramda'
import { fetchAuthUserRoutine, fetchPointsSummaryRoutine } from 'src/features/auth/duck/actions'
import { getOrganisationDetailsRoutine } from 'src/features/organisation/duck/actions'
import { fetchUserAppreciationCountersRoutine } from 'src/features/appreciations/duck/actions'
import { fetchCoreValuesRoutine } from 'src/features/coreValues/duck/actions'
import LocalStorageService from 'src/services/LocalStorageService'
import { KEYS } from 'src/utils/localStorage'

function createReduxStore() {
  const middleware = createSagaMiddleware()
  const loggerMiddleware = createLogger({ collapsed: true })
  const middlewares = [middleware]
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(loggerMiddleware)
  }
  const reduxDevtools =
    typeof window !== `undefined` && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : identity()
  const enhancer = compose(applyMiddleware(...middlewares), reduxDevtools)
  const store = createStore(rootReducer, enhancer)
  middleware.run(rootSaga)
  return store
}

let clientStore = null

function AuthDataLoader() {
  const dispatch = useDispatch()
  useEffect(() => {
    if (typeof window === 'undefined') return
    let unlisten
    try {
      let globalHistory
      try {
        globalHistory = require('@reach/router').globalHistory
      } catch (_) {}
      const maybeFetch = () => {
        const path = (globalHistory?.location?.pathname ?? window.location.pathname) || ''
        const token = LocalStorageService.get(KEYS.token)
        if (path.startsWith('/workspace') && token) {
          dispatch(fetchAuthUserRoutine())
          dispatch(getOrganisationDetailsRoutine())
          dispatch(fetchPointsSummaryRoutine())
          if (path.includes('appreciations')) {
            dispatch(fetchUserAppreciationCountersRoutine())
            dispatch(fetchCoreValuesRoutine())
          }
        }
      }
      maybeFetch()
      unlisten = globalHistory?.listen ? globalHistory.listen(maybeFetch) : undefined
    } catch (err) {
      console.error('[Panda AuthDataLoader] useEffect error', err)
    }
    return () => { if (typeof unlisten === 'function') unlisten() }
  }, [dispatch])
  return null
}

export default ({ element }) => {
  if (typeof window !== 'undefined' && !clientStore) {
    clientStore = createReduxStore()
  }
  const store =
    typeof window !== 'undefined' ? clientStore : createReduxStore()

  return (
    <Provider store={store}>
      <AuthDataLoader />
      {element}
    </Provider>
  )
}
